import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectBaggageAndPersonalItemsTravellerTugo = (state) => state.get('baggageAndPersonalItemsTravellerTugo');

const safeToJS = (val, defaultVal) =>
  (val && typeof val.toJS === 'function' ? val.toJS() : (Array.isArray(val) ? val : defaultVal));

const makeSelectBaggageAndPersonalItemsTravellerTugo = () =>
  createSelector(selectBaggageAndPersonalItemsTravellerTugo, (state) => ({
    whatExpensesAreYouClaimingFor: mapWithDefault(
      state,
      () => safeToJS(state.getIn(['form', 'whatExpensesAreYouClaimingFor']), []),
      []
    ),
    lostStolenOrDamagedItemsItems: mapWithDefault(
      state,
      () => safeToJS(state.getIn(['form', 'lostStolenOrDamagedItemsItems']), []),
      []
    ),
    cashItems: mapWithDefault(
      state,
      () => safeToJS(state.getIn(['form', 'cashItems']), []),
      []
    ),
    baggageDelayItems: mapWithDefault(
      state,
      () => safeToJS(state.getIn(['form', 'baggageDelayItems']), []),
      []
    ),
    hasLuggageBeenReturned: mapWithDefault(
      state,
      () => state.getIn(['form', 'hasLuggageBeenReturned']),
      null
    ),
    dateWhenLuggageWasReturned: mapWithDefault(
      state,
      () => state.getIn(['form', 'dateWhenLuggageWasReturned']),
      null
    ),
    wasLostOrDamagedByAirline: mapWithDefault(
      state,
      () => state.getIn(['form', 'wasLostOrDamagedByAirline']),
      null
    ),
    numberOfCheckedBags: mapWithDefault(
      state,
      () => state.getIn(['form', 'numberOfCheckedBags']),
      ''
    ),
    baggageCheckNumbers: mapWithDefault(
      state,
      () => state.getIn(['form', 'baggageCheckNumbers']),
      ''
    ),
    dateBaggageCheckIssued: mapWithDefault(
      state,
      () => state.getIn(['form', 'dateBaggageCheckIssued']),
      null
    ),
    dateLossReportedToAirline: mapWithDefault(
      state,
      () => state.getIn(['form', 'dateLossReportedToAirline']),
      null
    ),
    dateClaimedWithAirline: mapWithDefault(
      state,
      () => state.getIn(['form', 'dateClaimedWithAirline']),
      null
    ),
    lostOrDamagedAirlineItems: mapWithDefault(
      state,
      () => safeToJS(state.getIn(['form', 'lostOrDamagedAirlineItems']), []),
      []
    ),
    wasLostOrDamagedSomewhereElse: mapWithDefault(
      state,
      () => state.getIn(['form', 'wasLostOrDamagedSomewhereElse']),
      null
    ),
    descriptionBaggageLostOrDamaged: mapWithDefault(
      state,
      () => state.getIn(['form', 'descriptionBaggageLostOrDamaged']),
      ''
    ),
    otherLossOrDamageItems: mapWithDefault(
      state,
      () => safeToJS(state.getIn(['form', 'otherLossOrDamageItems']), []),
      []
    ),
    descriptionBaggageStolen: mapWithDefault(
      state,
      () => state.getIn(['form', 'descriptionBaggageStolen']),
      ''
    ),
    authorityReportedTheft: mapWithDefault(
      state,
      () => state.getIn(['form', 'authorityReportedTheft']),
      ''
    ),
    stolenBaggageItems: mapWithDefault(
      state,
      () => safeToJS(state.getIn(['form', 'stolenBaggageItems']), []),
      []
    ),
    dateBaggageSupposedToArrive: mapWithDefault(
      state,
      () => state.getIn(['form', 'dateBaggageSupposedToArrive']),
      null
    ),
    timeBaggageSupposedToArrive: mapWithDefault(
      state,
      () => state.getIn(['form', 'timeBaggageSupposedToArrive']),
      null
    ),
    dateBaggageActuallyArrived: mapWithDefault(
      state,
      () => state.getIn(['form', 'dateBaggageActuallyArrived']),
      null
    ),
    timeBaggageActuallyArrived: mapWithDefault(
      state,
      () => state.getIn(['form', 'timeBaggageActuallyArrived']),
      null
    ),
    hasReceivedAirlineRefund: mapWithDefault(
      state,
      () => state.getIn(['form', 'hasReceivedAirlineRefund']),
      null
    ),
    airlineRefundAmount: mapWithDefault(
      state,
      () => state.getIn(['form', 'airlineRefundAmount']),
      ''
    ),
    airlineRefundCurrency: mapWithDefault(
      state,
      () => state.getIn(['form', 'airlineRefundCurrency']),
      ''
    ),
  }));

const makeSelectBaggageAndPersonalItemsTravellerTugoErrors = () =>
  createSelector(selectBaggageAndPersonalItemsTravellerTugo, (state) => state.get('errors'));

export {
  makeSelectBaggageAndPersonalItemsTravellerTugo,
  makeSelectBaggageAndPersonalItemsTravellerTugoErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.BaggageAndPersonalItemsTraveller/selectors.js